
import React, {useEffect, useState} from 'react';
import {journey_progress} from '../../../service/journey'
import rombus from '../../../media/rombus.gif'

const JourneyCountBlock = ({prod_type=null, date_from=null, date_to=null, journey_step=0, title=null, sub_title=null, token}) => {

    const [jounrey_d, set_data] = useState(null);

    const  popd = (date_from, date_to, prod_type) => {
        const limit = 8;
        journey_progress(date_from, date_to, null, null, null, prod_type, token).then((d) => {
            if(d != null){
                set_data(d)
            }
        });
    }
    

    let cTitle = 'Accommodation Views';
    if(title != null){
        cTitle = title;
    }

    let cSubTitle = 'Users on accommodation page';
    if(sub_title != null){
        cSubTitle = sub_title;
    }


    useEffect(() =>{
        popd(date_from, date_to, prod_type);
    }, [])

    useEffect(() =>{
        if(date_from == null || date_to == null){
            return
        }
        popd(date_from, date_to, prod_type);

    }, [date_from, date_to])    

    useEffect(() =>{
        popd(date_from, date_to, prod_type);
    }, [prod_type])  



    if(jounrey_d == null){
        return <>
            <div className='countBlock'>
                <div className='countBlockTitle'>
                    {cTitle}
                </div>
                <div className='countBlockContent'>
                    <div style={{justifyContent: 'center'}}>
                            <img src={rombus}></img>
                    </div>
                </div>
            </div>
        </>
    }

    let count = 0;
    for(const x of jounrey_d){
        let lbl = ""

        if(prod_type == 2 && journey_step == 1 && x.step_desc != "Rooms"){
            continue
        }
  
        if(x.step == journey_step){
            count += x.count;
        }
        

   
    }

    const formatted = Number(count).toLocaleString('en-US');

    return (<div className='countBlock'>
        <div className='countBlockTitle'>
            {cTitle}
        </div>
        <div className='countBlockContent'>
            <div className='info'>{formatted}</div>
            <div className='info infosmall'>{cSubTitle}</div>
        </div>
    </div>)

}

export default JourneyCountBlock
